import React, { useEffect, useState } from 'react';
import { useSamarthDashboardContext } from 'utils/samarth-dashboard-context/hooks/useSamarthDashboardContext';
import WidgetWrapper from '../widget-wrapper/widget-wrapper';
import ChartSkeleton from '../../ui/chart-skeleton/chart-skeleton';
import AreaGraphCharts from '../../ui/areaChart/AreaChart';
import SingleTabTable from '../../ui/SingleTabTable';
import DispatchComplianceTable from '../../ui/tables/dispatch-compliance/dispatch-compliance-table';
import styles from '../maiWidgets/mai-widget.module.css';

export default function DispatchComplianceWidget() {
  const { state,fetchDispatchCompliance } = useSamarthDashboardContext();
  const [isOn, setIsOn] = useState(false);

  const globalViewMode = state.viewMode.globalViewMode;
  const chartData = state.dashboardData.dispatchCompliance;
  const loader = state.dashboardData.isLoading.dispatchCompliance;
  const globalFilterLoader = state.dashboardData.isLoading.globalFilter;
  const { filters } = state;

  useEffect(() => {
    if (globalFilterLoader) return;
    const { actionFilter = [], globalFilters = [] } = filters;
    const shouldFetch = !actionFilter || ["BG", "SmallC"].includes(actionFilter) || Object.keys(globalFilters).some(k => ["BG", "SmallC"].includes(k));
    if (shouldFetch) {
      fetchDispatchCompliance(filters);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalFilterLoader , filters.actionFilter , filters.globalFilters]);

  return (
    <WidgetWrapper
      title="Dispatch Compliance"
      isTableView={globalViewMode === 'table'}
      showBlueDot={globalViewMode === 'table' && filters?.actionFilter ? ["BG", "SmallC"].includes(filters.actionFilter) : false}
      isOn={isOn}
      setIsOn={setIsOn}
      toogleLables={['24hrs', '48hrs']}
    >
      {loader ? (
        <ChartSkeleton isOn={isOn} />
      ) : (
        <div style={{ height: '100%', overflowY: 'hidden' }} className='no-scrollbar'>
          {globalViewMode === 'graph' ? (
            <AreaGraphCharts
              data={chartData}
              valueKey={'value'}
              dataKey={'day'}
              gradients={[["#FFCC00", "#050F318F"], ["#FF7C7D", "#050F318F"]]}
              graphsNames={['hrs48', 'hrs24']}
              minWidthNeeded={!!filters.actionFilter}
              activeDots={['#FFD700', '#FF7C7D']}
              MyTooltipComponent={(props) => (
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ height: 8, width: 8, background: '#FFCC00', display: 'inline-block' }} />
                    <span>48 hrs : {props.payload.hrs48}%</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ height: 8, width: 8, background: '#FF7C7D', display: 'inline-block' }} />
                    <span>24 hrs : {props.payload.hrs24}%</span>
                  </div>
                </div>
              )}
            />
          ) : ["BG", "SmallC"].includes(filters.actionFilter || "") ? (
            <SingleTabTable
              data={chartData}
              keys={['day', isOn ? 'hrs48' : 'hrs24']}
              colorLogic={(value) => {
                if (value < 80) return styles.textRed;
                if (value < 95) return styles.textYellow;
                return styles.textGreen;
              }}
            />
          ) : (
            <DispatchComplianceTable data={chartData} />
          )}
        </div>
      )}
    </WidgetWrapper>
  );
}
